<template>
  <div class="phone_effect_box">
    <!-- 分割线 -->
    <div class="cut_off">
        <div class="div_green" v-show="numberVal == '1'? true: false"></div>
        <div class="div_blue"  v-show="numberVal == '2'? true: false"></div>
        <div class="div_yellow"  v-show="numberVal == '3'? true: false"></div>
    </div>
    <!-- 内容 -->
    <div class="box_content">
        <!-- green -->
        <div class="box_green"  v-show="numberVal == '1'? true: false">
          <div class="box_title">海量網購使用者</div>
          <div class="box_content_box">資訊時代網路使用頻率高，網購人口逐年遞增</div>
          <img class="box_img" src="../../../assets/img/home/icon_box_green.png" alt="">
          <div class="box_more">{{more}}</div>
        </div>
      <!-- blue -->
      <div class="box_blue"  v-show="numberVal == '2'? true: false">
        <div class="box_title">多種付款方式</div>
        <div class="box_content_box">不管是轉帳還是超商付款總有一種適合你</div>
        <img class="box_img" src="../../../assets/img/home/icon_box_blue.png" alt="">
        <div class="box_more">{{more}}</div>
      </div>
      <!-- yellow -->
      <div class="box_yellow"  v-show="numberVal == '3'? true: false">
        <div class="box_title">跨境多幣種支援</div>
        <div class="box_content_box">人民幣、美金、日圓，想賺錢，幣種絕對不是問題</div>
        <img class="box_img" src="../../../assets/img/home/icon_box_yellow.png" alt="">
        <div class="box_more">{{more}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'HomeEffect',
  props: {
  },
  data() {
    return {
      more: "了解更多",
      numberVal: 1,
    }
  },
  created(){

    // JQ动画：
    $(() =>{
      setInterval(() => {
        this.numberVal += 1;
        if(this.numberVal == '4'){
          this.numberVal = 1;
        }
      }, 3000);
    })

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .phone_effect_box {
    display: none;
    flex-direction: column;
    justify-content: flex-start;
  }
  /* 分割线 */
  .cut_off {
    display: flex;
    margin: .8vw 0 0 0;
  }
  .cut_off > div {
    flex: 1;
    height: 3.1vw;
  }
  .cut_off .div_green {
    background: #a0e557;
  }
  .cut_off .div_blue {
    background: #5789d6;
  }
  .cut_off .div_yellow {
    background: #f4b12a;
  }
  /* 内容 */
  .box_content {
    display: flex;
  }
  .box_content > div {
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid #e8e8e8;
  }
  .box_content .box_title {
    margin: 4.8vw 0 4.5vw 0;
    font-size: 8.5vw;
    font-weight: bold;
    color: #000000;
  }
  .box_content .box_content_box {
    font-size: 4vw;
    padding: 0 .8vw;
    text-align: center;
    color: #777777;
    margin-bottom: 1.6vw;
  }
  .box_content .box_img {
    width: 21.6vw;
    height: 26.7vw;
  }
  .box_content .box_more {
    cursor:pointer;
    font-size: 4.3vw;
    padding: 2.3vw 4.1vw;
    color: #ffffff;
    background: #000000;
    border-radius: 1.3vw;
    margin-bottom: 5.9vw;
  }
  .phone_effect_box .active_flex {
    display: flex;
  }


    /*  */
@media screen and (max-width:768px){

  /* 显示/隐藏 */
  .phone_effect_box {
    display: flex;
  }

}
</style>
